import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        sidebarToggled: false,
        isLoggedIn: !!localStorage.getItem('isLoggedIn'),
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
        token: localStorage.getItem('token')  || null,
        loading: false,
        types: {
            WEEKLY: 'Eβδομαδιαία συνδρομή',
            A_LA_CARTE: 'À la carte'
        },
        products: [],
        statuses: [
            {title: 'Προβολή όλων', status: null},
            {title: 'Σε επεξεργασία', status: 'PROCESSING'},
            {title: 'Ολοκληρωμένη', status: 'COMPLETED'},
            {title: 'Έχει αποσταλλεί', status: 'SHIPPING'},
            {title: 'Αναμένεται πληρωμή', status: 'PENDING_PAYMENT'},
            {title: 'Ακυρωμένη', status: 'CANCELLED'},
            {title: 'Έχει επιστραφεί', status: 'RETURNED'},
            {title: 'Πρόχειρη', status: 'DRAFT'}
        ],
        status_colors: {
            DRAFT: '#9ca3af',
            PROCESSING: '#16a34a',
            SHIPPING: '#84cc16',
            PENDING_PAYMENT: '#f59e0b',
            COMPLETED: '#3356A5',
            CANCELLED: '#dc2626',
            RETURNED: '#334155'
        },
        categoryLabels: {
            BREAKFAST: 'Πρωινό',
            LUNCH: 'Μεσημεριανό',
            DINNER: 'Βραδινό',
            SNACK: 'Σνακ',
            GRAB_GO_DINNER: 'Grab & Go Βραδινό',
            DESERT: 'Επιδόρπιο'
        },
        filters: null,
        extraAttributes: null,
        menu: [
            {
                title: 'Παραγγελίες',
                url: 'orders',
                icon: 'icon-database'
            },
            {
                title: 'Πρώτες ύλες',
                url: 'raw-materials',
                icon: 'icon-circle'
            },
            {
                title: 'Προϊόντα',
                url: 'products',
                icon: 'icon-box'
            },
            {
                title: 'Κουπόνια',
                url: 'coupons',
                icon: 'icon-tag'
            },
            {
                title: 'Στατιστικά',
                url: 'statistics',
                icon: 'icon-bar-chart-2'
            },
            {
                title: 'Χρήστες',
                url: 'users',
                icon: 'icon-user',
            },
            {
                title: 'Ρυθμίσεις',
                url:'settings',
                icon: 'icon-settings'
            }
        ]
    },

    mutations: {
        increment (state) {
            state.count++
        },
        setIsLoggedIn(state, value){
            state.isLoggedIn = value;
            if(!value) localStorage.removeItem('isLoggedIn');
            else localStorage.setItem('isLoggedIn', 'true');
        },

        setUser(state, user){
            state.user = user;
            localStorage.setItem('user', JSON.stringify(user));
        },
        
        setToken(state, token){
            state.token = token;
            localStorage.setItem('token', token);
            axios.defaults.headers.common['x-access-token'] = token;
        },
        setLoading(state, val){
            state.loading = val;
        },
        setSidebarToggled(state, val){
            state.sidebarToggled = val;
        },
        setFilters(state, val){
            state.filters = val;
        },
        setExtraAttributes(state, val){
            state.extraAttributes = val;
        }
    },
    getters:{
        getStatus: (state) => (status) => {
            return state.statuses.find(x => x.status === status)?.title
        },
    },

    actions:{

        init(context){
            if(!context.state.isLoggedIn) return;
        },

        login(context, data) {
            context.commit("setIsLoggedIn", true);
            context.commit("setUser", data.user);
            context.commit('setToken', data.token);
        },

        logout(context){
            context.commit("setIsLoggedIn", false);
            context.commit("setUser", {});
            context.commit("setToken", null);
        }
    }
});

export default store;